import { getAuthHeaders } from "../../../../utils/authUtils";
import { API_BASE_URL } from "../../../../environment";

export interface MailAuthFolder {
  mail_auth_folder_id: number;
  folder_key: string;
  folder_display_name: string;
  mail_auth_id: number;
  tenant_id: number;
  updated_by: number;
}

export interface MailAuthFolderListResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: MailAuthFolder[];
}

export interface MailAuthFolderFilters {
  mail_auth_folder_id?: number;
  folder_key?: string;
  folder_display_name?: string;
  tenant_id?: number;
  mail_auth_id?: number;
  updated_by?: number;
  mail_auth_ids?: string;
}

class MailAuthFolderService {
  private baseUrl = API_BASE_URL;

  async listFolders(page: number = 1, pageSize: number = 20, filters?: MailAuthFolderFilters): Promise<MailAuthFolderListResponse> {
    const headers = await getAuthHeaders();
    const tenantId = localStorage.getItem("selectedTenantId") || "";

    const params = new URLSearchParams();
    if (tenantId) params.set("tenant_id", tenantId);
    params.set("page_size", pageSize.toString());
    params.set("page", page.toString());
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params.set(key, value.toString());
        }
      });
    }

    const response = await fetch(`${this.baseUrl}/mail-auth-folder/?${params.toString()}`, {
      method: "GET",
      headers,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  }

  async getFolder(pk: number): Promise<MailAuthFolder> {
    const headers = await getAuthHeaders();
    const response = await fetch(`${this.baseUrl}/mail-auth-folder/${pk}/`, {
      method: "GET",
      headers,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  }

  async renameFolder(pk: number, folderDisplayName: string): Promise<MailAuthFolder> {
    const headers = await getAuthHeaders();

    const response = await fetch(`${this.baseUrl}/mail-auth-folder/${pk}/`, {
      method: "PATCH",
      headers,
      body: JSON.stringify({ folder_display_name: folderDisplayName }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  }
}

export default new MailAuthFolderService();
